import { Children, cloneElement, isValidElement, ReactNode } from 'react';

/**
 * Gives each tab/panel child `value={String(position)}` unless it already has
 * its own `value`. Positions count valid elements only, as v2 did:
 * `Children.map` also visits the `false`/`null` left by conditional children
 * (`{canSee && <MTab />}`), which would shift every later value and break the
 * pairing between `MTabList` and `MTabPanels`.
 */
export const withPositionalTabValues = (children: ReactNode): ReactNode => {
  let position = 0;

  return Children.map(children, (child) => {
    if (!isValidElement(child)) {
      return child;
    }
    const { value } = child.props as { value?: string };
    const positionalValue = String(position);
    position += 1;

    return cloneElement(child, {
      value: value ?? positionalValue,
    } as { value: string });
  });
};
